import MainRouter from "./routes";
import "./i18n";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { CssBaseline, PaletteMode } from "@mui/material";
import { getTheme } from "./theme";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectTheme, setTheme } from "./redux";

const App = () => {
  const dispatch = useDispatch();
  const { theme } = useSelector(selectTheme);
  const [mode, setMode] = useState<PaletteMode>("light");

  const handleChange = (event: MediaQueryListEvent) => {
    if (theme === "default") setMode(event.matches ? "dark" : "light");
  };

  useEffect(() => {
    console.log("theme", theme);

    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

    if (theme !== "default") {
      setMode(theme);
      dispatch(setTheme(theme));
    } else {
      setMode(mediaQuery.matches ? "dark" : "light");
    }

    mediaQuery.addEventListener("change", handleChange);

    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, [theme]);

  // Memoriza el tema para que solo se regenere cuando 'mode' cambie
  const themeMemo = useMemo(() => createTheme(getTheme(mode)), [mode]);
  return (
    <ThemeProvider theme={themeMemo}>
      <CssBaseline />
      <MainRouter />
    </ThemeProvider>
  );
};
export default App;
